<div class="flex" style="margin-top: 8px;">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <div class="p-datatable-header">
        <div class="flex flex-column sm:flex-row justify-content-between">
          <div class="flex flex-column md:flex-row">
            <button
              [label]="'common.new' | transloco"
              pButton
              pRipple
              class="md:mr-2 p-button-primary mb-2 md:mb-0"
              routerLink="new"
              icon="pi pi-plus"
            ></button>
            <button
              [label]="'common.delete' | transloco"
              [disabled]="selected.length == 0"
              (click)="confirmAndDeleteSelected()"
              pButton
              pRipple
              class="md:mr-2 p-button-danger mb-2 sm:mb-0"
              icon="pi pi-trash"
            ></button>
            <p-toggleButton
              [(ngModel)]="activeButtonState"
              [onLabel]="'misc.setActive' | transloco"
              [offLabel]="'misc.setInactive' | transloco"
              [disabled]="selected.length == 0" styleClass="w-full"
              (click)="selected.length > 0 ? changeActiveStates() : null"
              class="mb-2 sm:mb-0"
              onIcon="pi pi-check"
              offIcon="pi pi-times"
            ></p-toggleButton>
          </div>
          <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary"
              icon="pi pi-sliders-h"
            ></button>
          </div>
          <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary filtersFilled"
              icon="pi pi-filter"
            ></button>
          </div>
        </div>
      </div>
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [(selection)]="selected"
        [value]="defaultDevicesCatalog"
        [totalRecords]="totalCatalog"
        [responsive]="true"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onLazyLoad)="onPageChange($event)"
        styleClass="p-datatable-striped"
        sortField="name"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="w-3rem"></th>
            <th pSortableColumn="name">
              {{'attribute.name' | transloco}}
              <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="version">
              {{'attribute.version' | transloco}}
              <p-sortIcon field="version"></p-sortIcon>
            </th>
            <th pSortableColumn="active">
              {{'attribute.active' | transloco}}
              <p-sortIcon field="active"></p-sortIcon>
            </th>
            <th pSortableColumn="defaultDeviceCategory.name">
              {{'model.category' | transloco}}
              <p-sortIcon field="defaultDeviceCategory.name"></p-sortIcon>
            </th>
            <th pSortableColumn="defaultAssetRepresentation.name">
              {{'model.assetRepresentation' | transloco}}
              <p-sortIcon field="defaultAssetRepresentation.name"></p-sortIcon>
            </th>
            <th pSortableColumn="creationDate">
              {{'attribute.creationDate' | transloco}}
              <p-sortIcon field="creationDate"></p-sortIcon>
            </th>
            <th pSortableColumn="updatedDate">
              {{'attribute.updatedDate' | transloco}}
              <p-sortIcon field="updatedDate"></p-sortIcon>
            </th>
            <th class="w-10rem">
              {{'common.actions' | transloco}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-defaultDeviceCatalog>
          <tr *ngIf="!loadingCatalog" class="fadein">
            <td>
              <span class="p-column-title bold">{{'common.select' | transloco}}</span>
              <p-tableCheckbox (click)="evaluateActiveButtonState()" [value]="defaultDeviceCatalog"></p-tableCheckbox>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              <a [routerLink]="[defaultDeviceCatalog.uuid, 'details']">{{defaultDeviceCatalog.name}}</a>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.type' | transloco}}</span>
              <p class="text-right md:text-left">{{defaultDeviceCatalog.version}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.active' | transloco}}</span>
              <p *ngIf="defaultDeviceCatalog.active">{{'common.active' | transloco}}</p>
              <p *ngIf="!defaultDeviceCatalog.active">{{'common.inactive' | transloco}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'model.deviceCategory' | transloco}}</span>
              <p class="text-right md:text-left">{{defaultDeviceCatalog.defaultDeviceCategory.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'model.assetRepresentation' | transloco}}</span>
              <p class="text-right md:text-left">{{defaultDeviceCatalog.defaultAssetRepresentation.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.creationDate' | transloco}}</span>
              <p class="text-right md:text-left">{{defaultDeviceCatalog.creationDate | customDate}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.updatedDate' | transloco}}</span>
              <p class="text-right md:text-left">{{defaultDeviceCatalog.updatedDate | customDate}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  [routerLink]="[defaultDeviceCatalog.uuid, 'edit']"
                  class="p-button-rounded btn-primary-light mr-2"
                  pButton
                  pRipple
                  icon="pi pi-pencil"
                ></button>
                <button
                  (click)="confirmAndDelete(defaultDeviceCatalog)"
                  class="p-button-rounded btn-danger-light"
                  pButton
                  pRipple
                  icon="pi pi-trash"
                ></button>
              </div>
            </td>
          </tr>
          <tr *ngIf="loadingCatalog" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalCatalog == 0">
            {{'pagination.empty' | transloco}}
          </div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalCatalog > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalCatalog ? totalCatalog : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalCatalog}}
            {{(totalCatalog > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <div>
    <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="name">{{'attribute.name' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.name"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            appAutoFocus
            pInputText
            class="w-full"
            id="name"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="version">{{'attribute.version' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.version"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            pInputText
            class="w-full"
            id="version"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label>{{'attribute.active' | transloco}}</label>
        </div>
        <div class="col-12">
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.active"
              [label]="'misc.allTypes' | transloco"
              name="active"
              value="null"
            ></p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.active"
              [label]="'misc.activeOnly' | transloco"
              name="active"
              value="true"
            ></p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton
              [(ngModel)]="currentFilters.active"
              [label]="'misc.inactiveOnly' | transloco"
              name="active"
              value="false"
            ></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="defaultDeviceCategory">{{'model.category' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.defaultDeviceCategoryNames"
            [placeholder]="'select.generic' | transloco"
            [options]="defaultDeviceCategories"
            [filter]="true"
            [styleClass]="'w-full'"
            id="defaultDeviceCategory"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="defaultAssetRepresentation">{{'model.assetRepresentation' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.defaultAssetRepresentationNames"
            [placeholder]="'select.generic' | transloco"
            [options]="defaultAssetRepresentations"
            [filter]="true"
            [styleClass]="'w-full'"
            id="defaultAssetRepresentation"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="creationRangeDates">{{'attribute.creationDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar
            [(ngModel)]="creationRangeDates"
            [firstDayOfWeek]="1"
            [readonlyInput]="false"
            styleClass="w-full"
            id="creationRangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            appendTo="body"
            inputId="range"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="updateRangeDates">{{'attribute.updatedDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar
            [(ngModel)]="updateRangeDates"
            [firstDayOfWeek]="1"
            [readonlyInput]="false"
            styleClass="w-full"
            id="updateRangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            appendTo="body"
            inputId="range"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          [disabled]="!(
            currentFilters.name ||
            currentFilters.version ||
            (currentFilters.active != null) ||
            currentFilters.defaultDeviceCategoryNames ||
            currentFilters.defaultAssetRepresentationNames ||
            creationRangeDates ||
            updateRangeDates
          )"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false;"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </div>
</p-sidebar>
